module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-1ec5b76672b4f935d3c166f022ca501b.webp";